import { Link } from 'react-router-dom';
import { USER_ROLE_LABELS } from '@/config/permissions';
import { routePaths } from '@/routes/paths';
import { useAuth } from '@/shared/hooks/useAuth';

export function AccessDeniedPage() {
  const { profile } = useAuth();
  const roleLabel = profile?.role
    ? USER_ROLE_LABELS[profile.role]
    : 'sin rol asignado';

  return (
    <section className="auth-screen">
      <div className="auth-card auth-card--wide">
        <h1>Acceso denegado</h1>
        <p className="auth-muted">
          Tu rol actual (<strong>{roleLabel}</strong>) no tiene permiso para
          acceder a esta sección del ERP.
        </p>
        <p className="auth-muted">
          Si necesitás acceso, pedí al administrador que revise tu rol en{' '}
          <code>/admin/usuarios</code>.
        </p>
        <p>
          <Link to={routePaths.home}>Volver al inicio</Link>
        </p>
      </div>
    </section>
  );
}
